import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import store from "./redux/store";

import { MsalProvider } from "@azure/msal-react";
import { msalInstance, initializeMsal } from "./msalInstance";

const container = document.getElementById("root");

(async () => {
  try {
    await initializeMsal(); 
  } catch (error) {
    console.error("MSAL initialization failed:", error);
    return;
  }

  if (container) {
    const root = createRoot(container);
    root.render(
      <StrictMode>
        <MsalProvider instance={msalInstance}>
          <Provider store={store}>
              <App />
          </Provider>
        </MsalProvider>
      </StrictMode>
    );
  } else {
    console.error("Container element not found!");
  }

  serviceWorker.unregister(); // Or register() with proper cache control
})();